import {Inject, Injectable} from '@angular/core';
import {get} from 'lodash-es';
import token from '../token/tokens';
import {AppConfig} from '../models';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(@Inject(token.values.APP_CONFIG) public config: AppConfig) {}

  getString(valuePath: string, optionalDefaultValue?: string): string {
    return get(this.config, valuePath, optionalDefaultValue || '');
  }

  getStringArray(valuePath: string, optionalDefaultValue?: string[]): string[] {
    return get(this.config, valuePath, optionalDefaultValue || []);
  }

  getArray(valuePath: string, optionalDefaultValue?: any[]): any[] {
    return get(this.config, valuePath, optionalDefaultValue || []);
  }

  getObject(valuePath: string, optionalDefaultValue?: any): any {
    return get(this.config, valuePath, optionalDefaultValue || {});
  }

  getNumber(valuePath: string, optionalDefaultValue?: number): number {
    return get(this.config, valuePath, optionalDefaultValue || 0);
  }

  getBoolean(valuePath: string, optionalDefaultValue?: boolean): boolean {
    return get(this.config, valuePath, !!optionalDefaultValue);
  }

  /**
   * Check if the given url is part of our decorated endpoints
   *
   * @param url the url to test
   */
  isKymaUrl(url: string): boolean {
    return !!url && (this.isDecoratedEndpoint(url) || this.isNonDecoratedEndpoint(url));
  }

  isDecoratedEndpoint(url: string): boolean {
    const decoratedEndpoints = Object.values(this.getArray('kyma.decoratedEndpoints'));
    return (
      !!url &&
      decoratedEndpoints.filter((endpoint) => url.startsWith(endpoint.baseUrl) || url.startsWith(endpoint.baseUrlUdex))
        .length > 0
    );
  }

  isDecoratedStickyEndpoint(url: string): boolean {
    const decoratedEndpoints = Object.values(this.getArray('kyma.decoratedEndpoints'));
    return (
      !!url &&
      decoratedEndpoints.filter(
        (endpoint) =>
          (url.startsWith(endpoint.baseUrl) || url.startsWith(endpoint.baseUrlUdex)) && endpoint.stickySession === true,
      ).length > 0
    );
  }

  isNonDecoratedEndpoint(url: string): boolean {
    const namespaces: string[] = Object.values(this.getObject('kyma.namespace'));
    const namespacesUdex: string[] = Object.values(this.getObject('kyma.namespaceUdex'));
    return (
      !!url &&
      (namespaces.filter((endpoint) => url.startsWith(endpoint)).length > 0 ||
        namespacesUdex.filter((endpoint) => url.startsWith(endpoint)).length > 0)
    );
  }

  getDecoratedEndpoint(endpointToSearch: string): any {
    const decoratedEndpoints = Object.values(this.getArray('kyma.decoratedEndpoints'));
    return decoratedEndpoints.filter((endpoint) => endpointToSearch.startsWith(endpoint.code))[0];
  }

  isOccUrl(url: string): boolean {
    return (
      !!url &&
      (url.includes(this.getString('backend.occ.baseUrl')) || url.includes(this.getString('backend.occ.baseUrlUdex')))
    );
  }

  getTrustedDomains(): string[] {
    return this.getStringArray('trustedDomains');
  }
}
